<script>

    import { toast } from 'bulma-toast'
    import { notificationsStore, modalStore, adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import NotificationsService from '../$services/notifications.service'
    import DateMethods from '../$methods/date.methods.js'

    import Table from '../$components/table.svelte'
    import Button from '../$components/button.svelte'
    import ButtonModal from '../$components/button.modal.svelte'

    export let query = {
        type: 'user',
    }

    let loading = false

    $: compact = Boolean(query.userId)
    $: skeletonCols = compact ? 4 : 5
    $: queryKey = JSON.stringify(query)

    $: if (queryKey) getNotifications()

    async function getNotifications() {

        loading = true
        const resp = await NotificationsService.getNotifications(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        notificationsStore.set(resp.data.notifications)
    }

</script>

<Table items={ $notificationsStore.length } { loading } { skeletonCols }>
    <div slot="header" class="header-filters">
        {#if isPermission($adminStore, 'UsersView.Notification.Create')}
            <div class="header-actions">
                <ButtonModal modalId="notification_create_modal" text="Agregar" icon="plus" />
            </div>
        {/if}
    </div>
    <thead slot="thead">
        <tr>
            <th>#</th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-bell"></i></span>
                    <span>Tema</span>
                </span>
            </th>
            {#if !compact}
                <th>
                    <span class="icon-text">
                        <span class="icon"><i class="fas fa-comment"></i></span>
                        <span>Mensaje</span>
                    </span>
                </th>
            {/if}
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-calendar"></i></span>
                    <span>Fecha</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-ellipsis-v"></i></span>
                    <span>Acciones</span>
                </span>
            </th>
        </tr>
    </thead>
    <tbody slot="tbody">
        {#each $notificationsStore as notification, index}
            <tr>
                <td>{ index + 1 }</td>
                <td>{ notification.subject }</td>
                {#if !compact}
                    <td>{ notification.message }</td>
                {/if}
                <td>{ DateMethods.dateLarge(notification.created) }</td>
                <td>
                    <Button on:click={() => modalStore.open('notification', 'modal', notification)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>
